import { Inject, Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { APP_CONFIG, IAppConfig } from 'src/app/app.config/app.config';

@Injectable({
    providedIn: 'root',
})
export class CryptoService {
    secretKey: string;

    constructor(
        @Inject(APP_CONFIG)
        private iAppConfig: IAppConfig
    ) {
        this.secretKey = this.iAppConfig.privateKeyEncript;
    }

    decryptData(encryptedData: string): any {
        if (!encryptedData || typeof encryptedData !== 'string') {
            console.error('decryptData(): ciphertext inválido:', encryptedData);
            throw new Error('Invalid ciphertext');
        }

        const trimmed = encryptedData.trim();
        console.log(
            '🔐 decryptData() payload len:',
            trimmed.length,
            'sample:',
            trimmed.slice(0, 24)
        );

        // Backend usa passphrase -> decrypt directo
        let bytes = CryptoJS.AES.decrypt(trimmed, this.secretKey);
        let utf8 = bytes.toString(CryptoJS.enc.Utf8);

        // Fallback por las dudas
        if (!utf8) {
            try {
                const cipherParams = CryptoJS.lib.CipherParams.create({
                    ciphertext: CryptoJS.enc.Base64.parse(trimmed),
                });
                bytes = CryptoJS.AES.decrypt(cipherParams, this.secretKey);
                utf8 = bytes.toString(CryptoJS.enc.Utf8);
            } catch {}
        }

        if (!utf8) {
            throw new Error(
                'Empty result after decrypt (wrong key or corrupt payload)'
            );
        }

        return JSON.parse(utf8);
    }
}
